// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"184c4637","225":"9dd17c76","245":"59eec114","331":"b0432bba","556":"c9925e57","652":"21ea100e","817":"fc1cfffb","900":"efd83675","926":"83935d49","942":"0c11727a"}[chunkId] + ".chunk.js";
};